export function createSVGIcon(text = "专家经验", theme = "light") {
  let content = ""
  const strs = text?.split("") || []
  const isSmall = strs?.length <= 2
  const padding = isSmall ? 24 : 20
  for (let i = 0; i < strs?.length; i++) {
    const str = strs[i]
    content += `<tspan x="10" y="${padding * (i + 1)}">${str}</tspan>`
  }
  return `
    <svg 
      width="46" 
      height="${isSmall ? 90 : 130}" 
      viewBox="0 0 46 ${isSmall ? 90 : 130}" 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <defs>
          <linearGradient x1="45.848894%" y1="0%" x2="54.151106%" y2="100%" id="linearGradient-1">
              <stop 
                stop-color="var(--bookmark-active-bg-offset-0)" 
                offset="0%"
              ></stop>
              <stop 
                stop-color="var(--bookmark-active-bg-offset-100)" 
                offset="100%"
              ></stop>
          </linearGradient>
          <polygon 
            id="path-2" 
            points="${
              isSmall
                ? "6.61190883 0 34 0 34 81 7.15696092 81 0 74 0 6.25701346"
                : "6.61190883 0 34 0 34 118 7.15696092 118 0 110.506147 0 6.25701346"
            }"
          ></polygon>
          <filter x="-26.5%" y="-7.6%" width="152.9%" height="115.3%" filterUnits="objectBoundingBox" id="filter-3">
              <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
              <feGaussianBlur stdDeviation="3" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
              <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"></feComposite>
              <feColorMatrix values="0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.695968094  0 0 0 0.601125437 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
          </filter>
      </defs>
      <g id="颜色统一" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="画板备份-16" transform="translate(-541.000000, -249.000000)">
              <g id="编组-9" transform="translate(541.000000, 106.000000)">
                  <g id="编组-13备份-4" transform="translate(6.000000, 149.000000)">
                      <g id="矩形">
                          <use 
                            fill="black" 
                            fill-opacity="1" 
                            filter="${theme === "dark" ? "url(#filter-3)" : "none"}" 
                            xlink:href="#path-2"
                          ></use>
                          <use fill="url(#linearGradient-1)" fill-rule="evenodd" xlink:href="#path-2"></use>
                      </g>
                      <text 
                        id="智能推荐" 
                        font-family="SourceHanSansCN-Medium, Source Han Sans CN" 
                        font-size="14" 
                        font-weight="400" 
                        line-spacing="20" 
                        fill="var(--bookmark-active-color)"
                      >
                          ${content}
                      </text>
                      <polygon 
                        id="路径-76"
                        transform="${isSmall ? "translate(0, -37)" : "translate(0, 0)"}"
                        fill="var(--bookmark-active-color)" 
                        points="15 98 20 102.202761 15 106.405522"
                      ></polygon>
                  </g>
              </g>
          </g>
      </g>
    </svg>
  `
}

export function svgToDataURL(svg: string) {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
}
